/**
 * Created by anatoly on 25.09.26
 */

const MissionCollectDelta = {
    show: function (missionType, value, worldPosition) {
        const target = cleverapps.Scenes.GetMovingNode();
        const position = target.convertToNodeSpace(worldPosition);

        cleverapps.aims.showDelta(value, target, {
            type: `mission${missionType}`,
            icon: Mission.getCollectIcon(missionType),
            font: cleverapps.styles.FONTS.SCENE_ANIMATE_DELTA_TEXT,
            bg: bundles.game && bundles.game.frames.delta_bg_png,
            x: position.x,
            y: position.y
        });
    },

    showOver: function (missionType, value, source) {
        if (!source || !source.getParent()) {
            return;
        }

        MissionCollectDelta.show(missionType, value, source.convertToWorldSpace(cc.p(source.width / 2, source.height)));
    }
};
